<template> 
    <div class="page-main">
        <Banner :displayHomeButton="true" :displayProfileButton="true"></Banner>
        <div class="main-title">MY GO HISTORY</div>
        <v-row justify="center">
            <v-col cols="12" sm="10" md="8">
                <div class="card" v-for="item in items" :key="item.Id">
                    <div class="card-status" :style="item['Status__c']==='Successful' && 'color:#ea7f1d;'">{{item['Status__c']}}</div>
                    <div class="card-title">{{item['Scholarship__r']['Name']}}</div>
                    <div v-if="item['Status__c'] !== 'Incompleted'" class="card-bottom">
                        <!-- <div v-if="item['Status__c'] === 'Successful'" class="bottom-first"><span class="bottom-key">Active: </span>{{item['Active__c']}}</div> -->
                        <div class="bottom-part"><span class="bottom-key">Date of application: </span>{{item['Submitted_Date__c'] | moment("DD MMMM YYYY")}}</div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import Banner from './BannerComponent';
import Client from '../client.js';

export default {
    components: {
        Banner,
    },
    mounted() {
        this.fetchScholarships();
    },
    methods: {
        fetchScholarships() {
            const client = Client();
            client.get('me/history_applications').then(res => {
                this.items = res.data;
            }, () => {})
        }
    },
    data() {
        return {
            items: []
        };
    },
    computed: {
    },
}
</script>
<style lang="scss" scoped>
.main-title {
    font-family: $body-font-family;
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 4px;
    text-align: center;
    margin: 30px 0;
}
.card {
    border: solid 1px #a4a4a4;
    background-color: #ffffff;
    padding: 30px;
    margin-bottom: 20px;
}
.card-status {
    font-family: $btn-font;
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0.75px;
    color: #9a9a9a;
}
.card-title {
    font-family: $body-font-family;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 2.18px;
    margin-bottom: 10px;
}
.card-bottom {
    display: flex;
    align-items: center;
    font-family: $secondary-font;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
}
.bottom-key {
    font-weight: bold;
}
.bottom-first {
    flex-basis: 40%;
}
.bottom-part {
    flex: 1;
}

</style>
